/**
 * 创建人：zll
 * 时间：2020-6-22
 * 描述：抽屉组件封装（向左、向右、向上、向下滑动）
 * 使用说明: 参考 sw-drawer 配置应用说明文档  
 * 更新记录: 
 * 
 */
import { Input, Component, OnInit, HostListener, ElementRef, Output, EventEmitter } from '@angular/core';
declare var $: any;

/**
 * 抽屉组件封装   sw-drawer
 */
@Component({
  selector: 'sw-drawer',
  templateUrl: './sw-drawer.component.html',
  styleUrls: ['./sw-drawer.component.css']
})
export class SwDrawerComponent implements OnInit {

  /**
   * 点击的标题
   * @ignore 
   */
  @Input() boxTitle = ""

  /**
   * 表单的标题
   * @ignore 
   */
  @Input() headerTitle = ""
  /**
   * 盒子宽度 (当position值为left或right时有效=>即从左向右滑动或从右向左滑动时有效)
   * 盒子高度默认为calc(100% - 50px)
   * 其中50px为header的高度
   * @ignore 
   */
  @Input() width = "28%"
  /**
  * 盒子高度 (当position值为top或bottom时有效=>即从上向下滑动或从下向上滑动时有效)
  * 盒子宽度默认为100%;
  * @ignore 
  */
  @Input() height = "28%"

  /**
 * 是否只显示面板(为true 代表只显示可以向右滑动的面板 没有可点击的小标题)
 * @ignore 
 */
  @Input() isOnlyPanel: boolean = true

  /**
 * 是否点击面板以外时 该面板隐藏
 * @ignore 
 */
  @Input() isHidePanel: boolean = true
  /**
  * 面板滑动位置 默认left
  * left 从左往右滑动
  * right 从右往左滑动
  * top 从上往下滑动
  * bottom 从下往上滑动
  * @ignore 
  */
  @Input() position: string = 'right'

  /**
   * 类似表格列表 点击一行数据后 打开此面板 此后点击表格的各个行 显示对应数据 但面板不隐藏 除非点击面板的x号 或者保存取消成功后 隐藏
   */
  // @Input() isAlwaysShow: boolean = false;

  /**
  * 点击弹出框的 'X'  事件抛出
  */
  @Output() callback = new EventEmitter();
  /**
   * 从右向左滑动时，右面板隐藏时的定位
   * @ignore 
   */
  right: string = '-' + (parseInt(this.width.split('%')[0]) + 4) + '%'
  /**
   * 从左向右滑动时，左面板隐藏时的定位
   * @ignore 
   */
  left: string = '-' + (parseInt(this.width.split('%')[0]) + 4) + '%'
  /**
  * 从上向下滑动时，上面板隐藏时的定位
  * @ignore 
  */
  top: string = '-' + (parseInt(this.height.split('%')[0]) + 4) + '%'
  /**
   * 从下向上滑动时，下面板隐藏时的定位
   * @ignore 
   */
  bottom: string = '-' + (parseInt(this.height.split('%')[0]) + 4) + '%'
  /**
   * 隐藏，显示的切换
   * @ignore 
   */
  isStyle: boolean = false

  /**
   * 模态框的ID(用于多个模态框切换)
   * @ignore
   */
  ids: string;

  /**
   * @ignore
   */
  constructor(private _elementRef: ElementRef) { }

  /**
   * @ignore
   */
  ngOnInit() {
    //创建唯一id
    this.ids = "modal" + Math.random().toString().split(".")[1];
  }
  // 为true时表示面板显示
  show: boolean = false;
  /**
   * @ignore
   */
  ngAfterViewInit() {

  }

  //封装打开右侧面板方法
  open() {
    this.isStyle = false
    this.change()
  }
  //封装关闭右侧面板方法
  close() {
    this.isStyle = true
    this.change()
  }
  /**
   * 隐藏，显示的切换
   * @ignore 
   */
  change() {
    this.isStyle = !this.isStyle;
    //若为true 表示显示右侧盒子
    if (this.isStyle) {
      this.show = true;
      setTimeout(() => {
        //this.right = '0'
        this.matchPosition()
      }, 0)
    } else {
      //若为false 隐藏该盒子
      this.matchPosition()
     // this.right = '-' + (parseInt(this.width.split('%')[0]) + 4) + '%'
      setTimeout(() => {
        this.show = false;
      }, 300)
    }
  }

  /**
   * 关闭右边的表单
   * @ignore 
   */
  clickToClose() {
    let that = this
    this.isStyle = false;
    this.matchPosition()
    //this.right = '-' + (parseInt(this.width.split('%')[0]) + 4) + '%'
    setTimeout(() => {
      this.show = false;
      this.callback.next()
    }, 300)
  }
  //根据当前isStyle 和 position值 判断left right top bottom值
  matchPosition() {
    switch (this.position) {
      case 'left':
        if (this.isStyle) {
          this.left = '0'
        } else {
          this.left = '-' + (parseInt(this.width.split('%')[0]) + 4) + '%'
        };
        break;
      case 'right':
        if (this.isStyle) {
          this.right = '0'
        } else {
          this.right = '-' + (parseInt(this.width.split('%')[0]) + 4) + '%'
        };
        break;
      case 'top':
        if (this.isStyle) {
          this.top = '0'
        } else {
          this.top = '-' + (parseInt(this.height.split('%')[0]) + 4) + '%'
        };
        break;
      case 'bottom':
        if (this.isStyle) {
          this.bottom = '0'
        } else {
          this.bottom = '-' + (parseInt(this.height.split('%')[0]) + 4) + '%'
        };
        break;
    }
  }

  @HostListener('document:click', ['$event', '$event.target'])
  public onClick($event, targetElement) {
    if (this.isHidePanel) {
      let id = targetElement.id
      if (id == this.ids) {
        this.clickToClose()
      }
    }
    //slideCondition
    // if(this.isHidePanel){
    //   let classname= $event.toElement.className
    //   let index = classname.indexOf('slideCondition')
    //   const clickInside = this._elementRef.nativeElement.contains(targetElement)
    //   if(!clickInside && index < 0) {
    //      this.clickToClose()
    //    }
    // }

  }
  //根据position值 匹配出对应的样式值
  matchStyle() {
    let obj;
    switch (this.position) {
      case 'left':
        obj = { 'left': this.left, 'width': this.width,'z-index': 9990 };
        break;
      case 'right':
        obj = { 'right': this.right, 'width': this.width,'z-index': 9990 };
        break;
      case 'top':
        obj = { 'top': this.top, 'height': this.height,'z-index': 9990 };
        break;
      case 'bottom':
        obj = { 'bottom': this.bottom, 'height': this.height,'z-index': 9990 };
        break;
      default:
        obj = { 'right': this.right, 'width': this.width,'z-index': 9990 };
        break;
    }
    return obj

  }
}
